﻿import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import _ from 'lodash';
import { inputUniversalLocale } from '@/components/air/search-inputs/src/input-universal/locales';
import { getDraftingLocale } from '@/features/drafting/i18n';
import { getTelecomLocale } from '@/features/telecom/i18n';
import { getNoveltySearchLocale } from '@/features/novelty-search/i18n';

export function createI18nInstance(locale?: string) {
    locale = locale || getCurrentLanguage()
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: 'en',
        messages: {
            ...inputUniversalLocale,
        },
    })
}
export const i18n = createI18nInstance()

export async function loadI18n() {
    const lang = getCurrentLanguage()
    let results;
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/cn.json'),
            import('CommonMessages/eureka-common-errorcode/cn.json'),
            import('CommonMessages/eureka-air/cn.json')
        ])
    }
    if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/en.json'),
            import('CommonMessages/eureka-common-errorcode/en.json'),
            import('CommonMessages/eureka-air/en.json')
        ])
    }
    if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/jp.json'),
            import('CommonMessages/eureka-common-errorcode/jp.json'),
            import('CommonMessages/eureka-air/jp.json')
        ])
    }
    if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/tw.json'),
            import('CommonMessages/eureka-common-errorcode/tw.json'),
            import('CommonMessages/eureka-air/tw.json')
        ])
    }

    const data = results?.reduce((obj, { default: data }) => {
        return _.merge(obj, data);
    }, {});

    // @ts-ignore
    const mergedData = _.merge(data, getDraftingLocale(lang), getTelecomLocale(lang), getNoveltySearchLocale(lang));

    if (mergedData) {
        i18n.global.mergeLocaleMessage(lang, mergedData);
    }
    return i18n;
}
